<template>
    <div class="cp-main" >
        <!-- <el-drawer 
            title="新增常旅客" 
            :visible.sync="visible" 
            :direction="direction" 
            :before-close="cancel" 
            size="900px"
            :z-index="4000"
            :modal-style="{ zIndex: 3999 }"
        > -->
        <el-dialog
			class="text-left"
			title="新增常旅客"
			top="25vh"
			:fullscreen="maxScreen" 
			:modal="true"
			:close-on-click-modal="false"
			:modal-append-to-body="true"
			:append-to-body="true"
			:visible.sync="isVisibleAddCxr"
			:show-close="false"
			width="900px"
            
			>
            <div >

                <div class="dialog-content" style="min-height: 400px;">
                    <el-form :model="ruleForm" :inline="true" :rules="rules" ref="ruleForm" label-width="100px"
                        class="demo-ruleForm">
                        <div>
                            <el-form-item label="中文名字" prop="chName">
                                <el-input v-model="ruleForm.chName" placeholder="请输入中文名字"></el-input>
                            </el-form-item>
                            <el-form-item label="性别" v-if="isShowThCxr" >
                                <el-radio v-model="ruleForm.sex" label="M">男</el-radio>
                                <el-radio v-model="ruleForm.sex" label="F">女</el-radio>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="出生日期" prop="born" v-if="isShowThCxr">
                                <el-date-picker v-model="ruleForm.born" type="date" value-format="yyyy-MM-dd" :append-to-body="false"
                                    placeholder="选择出生日期"
                                    @change="changeRuleForm(ruleForm.born,'born')"
                                    :picker-options="pickerOptions()"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="国籍" prop="nation" v-if="isShowThCxr">
                                <el-select v-model="ruleForm.nation" filterable :filter-method="sreachGJ" :popper-append-to-body="false"
                                    placeholder="请选择国籍"
                                    @change="changeRuleForm(ruleForm.nation,'nation')"
                                    >
                                    <el-option v-for="item in nationList" :key="item.id" :label="item.cName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div>
                            <el-form-item label="手机号码" prop="phoneNumber">
                                <el-input v-model="ruleForm.phoneNumber" type="number" placeholder="请输入手机号码"></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="ruleForm.email" type="email" placeholder="请输入邮箱"></el-input>
                            </el-form-item>
                        </div>
                        <div v-if="isShowThCxr">
                            <div >
                                <el-form-item label="证件类型" prop="useCardType">
                                    <el-select 
                                        v-model="ruleForm.useCardType"  
                                        placeholder="请选择证件类型"
                                        :popper-append-to-body="false"
                        
                                    >
                                        <el-option v-for="item in filterIdTypeList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div v-for="(cardItem,cardIndex) in ruleForm.idCardList" :key="'cardIndex_' + cardIndex" >
                                <div v-if="cardItem.idType == ruleForm.useCardType">
                                    <div v-if="cardItem.idType != 1">
                                        <el-form-item label="英文姓" >
                                            <el-input v-model="cardItem.firstName" type="text" placeholder="请输入英文姓"></el-input>
                                        </el-form-item>
                                        <el-form-item label="英文名" >
                                            <el-input v-model="cardItem.lastName" type="text" placeholder="请输入英文名"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div>
                                        <el-form-item label="证件号码" >
                                            <el-input v-model="cardItem.idNo" type="text" placeholder="请输入证件号码"></el-input>
                                        </el-form-item>
            
                                        <el-form-item label="证件有效期">
                                            <el-date-picker v-model="cardItem.validDate" type="date" value-format="yyyy-MM-dd" :append-to-body="false"
                                                placeholder="选择证件有效期"
                                                @change="changeIdcardList(cardItem.validDate,cardIndex,'validDate')"
                                                :picker-options="pickerOptionsForValidDate()"
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                    </div>
                                    <div v-if="cardItem.idType != 1">   
                                        <el-form-item label="证件签发地" prop="nation">
                                            <el-select v-model="cardItem.placeOfIssue" filterable :filter-method="sreachQFD" :popper-append-to-body="false"
                                                placeholder="请选择证件签发地"
                                                @change="changeIdcardList(cardItem.placeOfIssue,cardIndex,'placeOfIssue')"
                                            >
                                                <el-option v-for="item in placeOfIssueList"  :key="item.id" :label="item.cName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                                

                            </div>
                        </div>


                    </el-form>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="determine" :loading="isLoading">确 定</el-button>
                </span>
            </div>


        </el-dialog>
    </div>
</template>

<script>

import validObj from '@/plugins/valid.js'


export default {
    name: "CxrList",
    props: {
        // 因公，因私 控制常旅客回显
        tripType: {
            type: Number,
            default() {
                return 1
            }
        },
        // 控制 显示隐藏
        isVisibleAddCxr: {
            type: Boolean,
            default() {
                return false
            }
        },
        proType:{
            type:[String, Number],
			default() {
				return ''
			}
        }

    },
    data() {
        var validateEmail = (rule, value, callback) => {
            if (value ) {
                let bool = validObj.isValidEmail(value);
                if(!bool){
                    callback(new Error('请检查邮箱格式'));
                }else{
                    callback();
                }
            }  else {
                callback();
            }
        };
        return {
            direction: 'rtl',
            visible: false,
            maxScreen: false, // 出行人最大框
            cheight: 0,
            ruleForm: {
                birthPlace: "",
                born: "",
                email: "",
                engName: "",
                idNumber: "",
                nation: "",
                passport: "",
                passportPeriod: "",
                phoneNumber: "",
                phoneNumber2: "",
                placeOfIssue: "",
                preference: "", //个人喜好
                sex: "M",
                tel: "",
                useCardType:'1',
                idCardList:[
                    {
                        idType: 1,
                        idNo: '',
                        validDate: '',
                        placeOfIssue: '',
                        placeOfIssueName: '',
                        firstName: '',
                        lastName: '',
                    },
                    {
                        idType: 2,
                        idNo: '',
                        validDate: '',
                        placeOfIssue: '',
                        placeOfIssueName: '',
                        firstName: '',
                        lastName: '',
                    },
                ],
            },
            rules: {
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '手机号长度为11位', trigger: 'blur' },
                ],
                nation: [
                    { required: true, message: '请选择国家', trigger: 'change' },
                ],
                idNumber: [
                    { required: true, message: '请输入证件号', trigger: 'blur' },
                    { min: 18, max: 18, message: '证件号长度为18位', trigger: 'blur' }
                ],
                email:[
                    { validator: validateEmail, trigger: 'blur' }
                ]
            },
            newNationList:[],
            nationList: [],
            placeOfIssueList:[],
            birthPlaceList:[],

            filterIdTypeList:[],

            isLoading:false,
        }
    },
    mounted() {

    },
    watch: {

        isVisibleAddCxr(bool) {
            if (bool) {
                this.initData();
            }
        },


    },
    computed:{
        // 
        isShowThCxr(){
				let proType = this.proType + '';
				if(proType.indexOf('10903') > -1  || proType.indexOf('10906') > -1 ) {
					return false
				}else{
					return true
				}
			},
    
    },
    methods: {
        // 初始化数据
        initData() {
            this.getNontion();

            this.getIdCardList();
        },
        cancel() {
          
            this.$emit('cancel',false)
        },
        // 出生日期限制
        pickerOptions(minDay,maxDay){
				// let minTime = this.$common.getStartDateTimeStamp(minDay);
				// let maxTime = this.$common.getStartDateTimeStamp(maxDay);
				return {
						disabledDate(time) {
							return  time.getTime() > new Date().getTime();
						},
				}
		},
        pickerOptionsForValidDate(){
            return {
				disabledDate(time) {
					return  time.getTime() < new Date().getTime();
				},
			}
        },
        getfilterIdTypeList(){
            let obj = {}; 
            if(this.editCxrType == 1){
                obj =  {
                    "1": "身份证",
                    "2": "护照",
                    "3": "港澳通行证",
                    // "4": "台胞证",
                    // "5": "回乡证",
                    "6": "台湾通行证",
                    // "7": "学生证",
                    // "8": "军官证",
                    // "9": "其他证件",
                    "10": "外来人永久居留证",
                }
            }else{
                obj = {
                "1": "身份证",
                "2": "护照",
                "3": "港澳通行证",
                "4": "台胞证",
                "5": "回乡证",
                "6": "台湾通行证",
                "7": "学生证",
                "8": "军官证",
                "9": "其他证件",
                "10": "外来人永久居留证",
            }
            }

            return Object.entries(obj).map(([key, label]) => ({
                value: key,
                label: label,
            }));
        },
        getIdCardList(){
            this.filterIdTypeList = this.getfilterIdTypeList();
            let oldIdList = this.ruleForm.idCardList || [];

            let arr = this.filterIdTypeList.map(item=>{
                let objItem = {
                        idType: item['value'],
                        idNo: '',
                        validDate: '',
                        placeOfIssue: '',
                        placeOfIssueName: '',
                        firstName: '',
                        lastName: '',
                }
                let filterList = oldIdList.map(oItem=>oItem['idType'] == item['value'])
                if(filterList.length>1){
                    let firstItem = filterList[0] || {};
                    objItem = {
                        ...objItem,
                        ...firstItem,
                    }
                }

                return objItem

            })
            this.ruleForm.idCardList = arr
        },
        // 获取国家信息
        getNontion(type) {
            let dataList = this.$common.localget('nationList') || [];
            if(dataList.length > 0){
                this.getListByType(type,dataList)
            }else{
                this.getNaitonListAjax(type);
            }
        },
        getNaitonListAjax(type){
            this.$conn.getConn('commu.baseData', { jsfile: true })({}).then((res) => {
                let data = res || {};
                let dataList = [];

                for (let key in data.country) {
                    dataList.push(data.country[key]);
                }

                this.$common.localset('nationList',dataList)
            
                this.getListByType(type,dataList)
            })
        },
        getListByType(type,dataList){
            if (type == 'nation') {
                    this.nationList = dataList;
                } else if (type == 'placeOfIssue') {
                    this.placeOfIssueList = dataList;
                } else if (type == 'birthPlace') {
                    this.birthPlaceList = dataList;
                } else {
                    this.nationList = dataList;
                    this.placeOfIssueList = dataList;
                    this.birthPlaceList = dataList;
                }
                this.newNationList = dataList;
        },
        // 搜索国家
        sreachGJ(e) {
            if (e) {
                this.nationList = this.newNationList.filter((item, index) => {
                   return  (
                        (item.by1 ||'').indexOf(e.toUpperCase()) != -1 
                        || 
                        (item.cName || '').indexOf(e.toUpperCase()) != -1
                    )
                })
            } else {
                this.getNontion('nation')
            }
        },
        // 签发地
		sreachQFD(e){
            
			if(e){
				this.placeOfIssueList = this.newNationList.filter((item, index) => {
                   return  (
                        (item.by1 ||'').indexOf(e.toUpperCase()) != -1 
                        || 
                        (item.cName || '').indexOf(e.toUpperCase()) != -1
                    )
                })
			}else{
				this.getNontion('placeOfIssue')
			}
		},
        // 计算title
        calcTitle(item) {
            return item.empName + '(' + (!item.empNo ? '' : item.empNo) + '/' + (item.deptName || '') + ')'
        },
        // 是否全屏显示
        changeMaxScreen(bool) {
            this.maxScreen = bool;
            this.cheight = document.body.clientHeight - 280;
        },
        changeIdcardList(val,cardIndex,attrName){
				if(attrName == 'validDate'){
					let date = this.$dateTime.YMDFormat(val);
					this.ruleForm['idCardList'][cardIndex][attrName] = date;
				}else if(attrName == 'placeOfIssue'){
					this.ruleForm['idCardList'][cardIndex][attrName] = val;
					for(var k=0;k<this.newNationList.length;k++){
						if(this.newNationList[k]['id'] == val){
							this.ruleForm['idCardList'][cardIndex]['placeOfIssueName'] = this.newNationList[k]['cName'];
							break;
						}
					}
					
					
				}else{
					this.ruleForm['idCardList'][cardIndex][attrName] = val;
				}
				

		},
        changeRuleForm(val,attrName){
            if(attrName == 'born'){
				let date = this.$dateTime.YMDFormat(val);
				this.ruleForm[attrName] = date;
			}else if(attrName == 'nation'){
				this.ruleForm[attrName] = val;
				for(var k=0;k<this.newNationList.length;k++){
					if(this.newNationList[k]['id'] == val){
						this.ruleForm['nationName'] = this.newNationList[k]['cName'];
						break;
					}
				}
			}else{
				this.ruleForm[attrName] = val;
			}
        },
        // 保存
        determine(){
            this.isLoading = true;
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    
                    if( this.isShowThCxr){
                        if(this.validIdCard() ) {
                            this.determineAjax();
                        }else{
                            this.isLoading = false;
                            this.$alert('请至少填写一种证件类型的证件号！', {
                                type:'error',
                                confirmButtonText: '确定',
                                zIndex: 100005,  // 单独设置更高的层级
                                callback: action => {
                                    
                                }
                            });
                        }
                    }else{
                        this.determineAjax();
                    }

                } else {
                    this.isLoading = false;
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        validIdCard(){
            let filterIdCardList = this.ruleForm.idCardList.filter(item=>{
                return item.idNo
            })

            return filterIdCardList.length>0
        },
        // 提交订单
        determineAjax(data) {

            let queryObj = {
                birthDate: this.ruleForm.born || this.ruleForm.birthDate ||  '',
                birthPlace: this.ruleForm.birthPlace || '',
                chName: this.ruleForm.chName || '',
                contactsId: this.ruleForm.contactsId || '',
                email:this.ruleForm.email || '',
                enName: this.ruleForm.enName || '',
                idNumber: this.ruleForm.idNumber || '',
                idcardList:this.ruleForm.idCardList || '',
                passport: this.ruleForm.passport || '',
                passportPeriod: this.ruleForm.passportPeriod || '',
                phoneNumber:this.ruleForm.phoneNumber || '',
                nation: this.ruleForm.nation || '',
                nationName: this.ruleForm.nationName || '',
                // "placeOfIssue": formData.value.placeOfIssue,
                sex: this.ruleForm.sex || '',
                tel:this.ruleForm.tel || '',
                cxrType: 2,
            };
            
            let queryUrl = "user.contactsEdit";
            this.$conn.getConn(queryUrl, { jsfile: false })(queryObj, (res) => {
                this.isLoading = false;
                this.$alert('新增成功', {
				    confirmButtonText: '确定',
                    zIndex: 100005,  // 单独设置更高的层级
				    callback: action => {
                     
						this.$emit('confirm',true)
					}
				});
                
            }, (err) => {
                this.isLoading = false;
                this.$alert(err.tips, {
				    confirmButtonText: '确定',
                    zIndex: 100005,  // 单独设置更高的层级
				    callback: action => {
				
					}
				});
            })
        },


    }
}
</script>

<style scoped lang="scss">
/deep/ .el-select .el-input__inner {
    width: 200px;
}

/deep/ .el-date-editor--date {
    width: 200px;
}
/deep/ .el-select-dropdown.el-popper{
    z-index: 100000;
}
.width34 {
    width: 34%;
}

.width66 {
    width: 66%;
}

.width100 {
    width: 100%;
}

.width50 {
    width: 50%;
}

/deep/ .is-fullscreen {
    min-width: 760px;
}

.pointer {
    cursor: pointer;
}

.font18 {
    font-size: 18px;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

.colorBlue {
    color: #4089FF;
}

.bg-c {
    background: #eee;
}

.inlineBlock {
    display: inline-block;
}

.padBtm10 {
    padding-bottom: 10px;
}

.padTop20 {
    padding-top: 20px;
}

.padTop10 {
    padding-top: 10px;
}

.padBtm20 {
    padding-bottom: 20px;
}

.flex {
    display: flex;
}

.between {
    justify-content: space-between;
}

.line-h30 {
    line-height: 30px;
}

.cp-yg {
    .cp-yg-p {
        padding: 10px 15px;
    }
}

.border {
    border: 1px solid #ccc;
}

.borderR {
    border-right: 1px solid #ccc;
}

.border-btm {
    border-bottom: 1px solid #ccc;
}

.cp-con {
    border: 1px solid #ccc;
    height: 298px;
}

.cp-con-tree {
    height: 256px;
    overflow-y: auto;
    overflow-x: hidden;
}


/deep/ .el-dialog__body {
    padding: 10px 20px 20px 20px;
}

.v-modal {
    z-index: 10000 !important;
}

.el-dialog__wrapper {
    z-index: 10001 !important;
}

.cp-p-title {
    background: #eee;
    padding: 10px 0px 10px 10px;
    border-bottom: 1px solid #ccc;
}

.cxr-list-box {
    height: 206px;
    padding-top: 10px;
    overflow-y: auto;
    overflow-x: hidden;

    .cxrItem {
        padding: 0 0 0 15px;
        cursor: pointer;
        display: flex;

        .cxrName {
            display: inline-block;
            width: calc(100% - 30px);
            padding: 5px 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .cxrIcon {
            display: inline-block;
            width: 30px;
            line-height: 30px;
        }
    }

    .cxrItem:hover {
        background-color: #f0f0f0;
    }

}

.marLeft40 {
    margin-left: 40px;
}

.marR10 {
    margin-right: 10px;
}

.tab-qh {
    width: 100%;
    padding: 0 0 10px 0;
    font-size: 16px;

    .primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }

}

.clk-xx {
    padding: 10px 0;
    height: auto;
    overflow-y: auto;

    .clkys {
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
    }

    .clkys:hover {
        background-color: #F5F7FA;
        cursor: pointer;
    }
}
 .dialog-footer{
    display: block;
    width: 100%;
    text-align: center;
}
</style>
